// import pages

import {
  About,
  Contact,
  Home,
  Projects
} from './pages'
import {
  Footer,
  Navbar,
  Sidebar
} from './components'
import {
  Route,
  BrowserRouter as Router,
  Routes,
} from "react-router-dom";

// import components



function App() {


  return (
    <Router>
      <Navbar />
      <Sidebar />
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='about' element={<About />} />
        <Route path='projects' element={<Projects />} />
        <Route path='contact' element={<Contact />} />
        <Route path='*' element={<Home />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
